exports.onWindowKeyboard = function (cb) {
  return function () {
    window.addEventListener("keydown", function (e) {
      cb(e.keyCode)();
    });
  };
};
